// src/services/wishlistService.js
import axios from "axios";
import API_BASE_URL from "../config/apiConfig";

const API = `${API_BASE_URL}/api/wishlist`;

export const toggleWishlist = async (userId, tripSlug) => {
  const response = await axios.post(`${API}/toggle`, null, {
    params: { userId, tripSlug },
  });
  return response.data;
};

export const fetchWishlist = async (userId) => {
  const response = await axios.get(`${API}/${userId}`);
  return response.data; // list of slugs
};
